import { create } from "zustand";
import { WEB_PARAMS } from "../config/Constant";

const useAuthStore = create((set, get) => ({
  accessToken: localStorage.getItem(WEB_PARAMS.ACCESS_TOKEN) || null,
  refreshToken: localStorage.getItem(WEB_PARAMS.REFRESH_TOKEN) || null,
  isLoggedIn: !!localStorage.getItem(WEB_PARAMS.ACCESS_TOKEN),
  userProfile: null,

  login: ({ access, refresh }) => {
    localStorage.setItem(WEB_PARAMS.ACCESS_TOKEN, access);
    localStorage.setItem(WEB_PARAMS.REFRESH_TOKEN, refresh);
    set({ accessToken: access, refreshToken: refresh, isLoggedIn: true });
  },

  logout: () => {
    localStorage.removeItem(WEB_PARAMS.ACCESS_TOKEN);
    localStorage.removeItem(WEB_PARAMS.REFRESH_TOKEN);
    set({ accessToken: null, refreshToken: null, isLoggedIn: false, userProfile: null });
  },

  // Manual Profile Update
  setUserProfile: (profile) => set({ userProfile: profile }),
}));

export default useAuthStore;
